import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuote = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.70922 20.6681C9.40067 20.9681 8.98223 21.1366 8.54593 21.1366C8.10964 21.1366 7.6912 20.9681 7.38265 20.6681L1.4823 14.9316C1.3294 14.783 1.2081 14.6066 1.12535 14.4124C1.04259 14.2182 1 14.0101 1 13.7999C1 13.5897 1.04259 13.3816 1.12535 13.1874C1.2081 12.9932 1.3294 12.8168 1.4823 12.6682L13 1.46826C13.1529 1.31971 13.3343 1.2019 13.534 1.12156C13.7337 1.04121 13.9477 0.999905 14.1638 1H20.0631C20.4995 1 20.918 1.16857 21.2265 1.46863C21.5351 1.76868 21.7085 2.17564 21.7085 2.59999V8.33754C21.7084 8.76159 21.5352 9.16826 21.2269 9.4682",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5944 4.59987C17.513 4.59987 17.4335 4.62333 17.3659 4.66728C17.2982 4.71123 17.2455 4.7737 17.2143 4.84679C17.1832 4.91988 17.1751 5.00031 17.1909 5.0779C17.2068 5.15549 17.246 5.22677 17.3035 5.28271C17.361 5.33865 17.4343 5.37674 17.5141 5.39218C17.5939 5.40761 17.6766 5.39969 17.7518 5.36941C17.827 5.33914 17.8912 5.28787 17.9364 5.22209C17.9816 5.15631 18.0057 5.07898 18.0057 4.99987C18.0057 4.89378 17.9624 4.79204 17.8853 4.71702C17.8081 4.64201 17.7035 4.59987 17.5944 4.59987Z",
			fill: "#17191C",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0635 15.3999H17.8334C17.4909 15.3989 17.1588 15.5141 16.8943 15.7256C16.6298 15.9372 16.4495 16.2319 16.3845 16.5589C16.3195 16.8859 16.3739 17.2247 16.5383 17.5169C16.7027 17.809 16.9667 18.0363 17.285 18.1594L19.5479 19.0405C19.865 19.1645 20.1278 19.392 20.2912 19.6838C20.4547 19.9757 20.5086 20.3138 20.4438 20.6401C20.3789 20.9664 20.1993 21.2606 19.9358 21.4722C19.6723 21.6838 19.3412 21.7997 18.9995 21.7999H16.7727",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4173 15.4V14.6",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4173 22.5997V21.7997",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4185 24.9999C22.0533 24.9999 25 22.1346 25 18.6C25 15.0654 22.0533 12.2 18.4185 12.2C14.7836 12.2 11.8369 15.0654 11.8369 18.6C11.8369 22.1346 14.7836 24.9999 18.4185 24.9999Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgQuote;
